var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FFD664"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50C100 44.375 99.0625 38.9453 97.3438 33.9062C94.2969 57.6562 80.2344 101.445 17.2266 87.7734C26.0156 95.3906 37.4609 100 50 100C77.6172 100 100 77.6172 100 50Z",
    fill: "black",
    fillOpacity: 0.0235294
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M18.5544 24.7648C17.7731 24.7648 16.9528 24.4914 16.2888 23.9445C14.8044 22.6945 14.6091 20.468 15.8591 18.9836C24.4919 8.74922 34.6481 6.83516 35.0778 6.75704C36.9919 6.40547 38.8278 7.69454 39.1403 9.6086C39.4919 11.5227 38.2028 13.3195 36.3278 13.6711C36.1325 13.7102 28.0856 15.3508 21.2106 23.4758C20.5466 24.3352 19.5309 24.7648 18.5544 24.7648Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6719 56.7578C77.215 56.7578 84.1406 49.8322 84.1406 41.2891C84.1406 32.7459 77.215 25.8203 68.6719 25.8203C60.1287 25.8203 53.2031 32.7459 53.2031 41.2891C53.2031 49.8322 60.1287 56.7578 68.6719 56.7578Z",
    fill: "#F7F7F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9609 53.2422C69.6208 53.2422 73.3984 49.4646 73.3984 44.8047C73.3984 40.1448 69.6208 36.3672 64.9609 36.3672C60.301 36.3672 56.5234 40.1448 56.5234 44.8047C56.5234 49.4646 60.301 53.2422 64.9609 53.2422Z",
    fill: "#232323"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3281 56.7578C39.8713 56.7578 46.7969 49.8322 46.7969 41.2891C46.7969 32.7459 39.8713 25.8203 31.3281 25.8203C22.785 25.8203 15.8594 32.7459 15.8594 41.2891C15.8594 49.8322 22.785 56.7578 31.3281 56.7578Z",
    fill: "#F7F7F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0391 53.2422C39.699 53.2422 43.4766 49.4646 43.4766 44.8047C43.4766 40.1448 39.699 36.3672 35.0391 36.3672C30.3792 36.3672 26.6016 40.1448 26.6016 44.8047C26.6016 49.4646 30.3792 53.2422 35.0391 53.2422Z",
    fill: "#232323"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9298 24.9991C16.9142 24.9991 15.8985 24.96 14.8439 24.8038C13.2814 24.6085 12.1876 23.2022 12.3829 21.6397C12.5782 20.0772 13.9845 18.9835 15.547 19.1788C26.4845 20.4678 34.7657 12.3819 34.8829 12.3038C35.9767 11.21 37.7735 11.21 38.9064 12.3038C40.0001 13.3975 40.0001 15.1944 38.9064 16.3272C38.4376 16.6788 29.961 24.9991 17.9298 24.9991ZM82.0704 24.9991C70.0392 24.9991 61.5626 16.7178 61.172 16.3272C60.0782 15.2335 60.0392 13.4366 61.172 12.3038C62.2657 11.21 64.0626 11.171 65.1564 12.3038C65.2735 12.421 73.6329 20.5069 84.4923 19.1788C86.0548 18.9835 87.461 20.1163 87.6563 21.6397C87.8517 23.2022 86.7189 24.6085 85.1954 24.8038C84.1017 24.921 83.047 24.9991 82.0704 24.9991Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableUser);
export default __webpack_public_path__ + "static/media/disableUser.fdac43acc3d60059ab326b64ca84fcfd.svg";
export { ForwardRef as ReactComponent };